import { useState } from "react";

const EconomicCalendarContentSix = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "What is the Economic Calendar used for?",
      text: `It helps traders track major financial events and releases that can impact global markets.`,
    },
    {
      title: "How often is the data updated?",
      text: `The calendar refreshes in real time as official reports are published.`,
    },
    {
      title: "Can I customize the events shown?",
      text: `Yes, you can filter by date, country, event type, or expected market impact.`,
    },
    {
      title: "Is it available for mobile users?",
      text: `Absolutely, you can access the full calendar from The Pips mobile app or browser.`,
    },
    {
      title: "What type of events does it include?",
      text: `It lists all key economic events such as inflation data, interest rate decisions, and employment reports.`,
    },
    {
      title: "Can I get alerts for specific events??",
      text: `Yes, you can set up custom alerts for important releases to receive instant notifications.`,
    },
    // {
    //   title: "Does the Economic Calendar support multiple time zones?",
    //   text: `Yes, it automatically adjusts to your local time zone for convenient global tracking.`,
    // },
  ];

  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE IMAGE + TEXT */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Why Traders Depend on The Pips Economic Calendar</h2>
              <p>
                Timing is everything in trading and information is your greatest
                advantage. The Pips Economic Calendar gives you a strategic edge
                by combining accuracy, speed, and clarity in one tool trusted by
                professionals worldwide.
              </p>
            </div>
            <div className="thumb-left">
              <img
                src={process.env.PUBLIC_URL + "/images/resources/economic_calendar/economic_calendar_4.png"}
                alt="computer images"
              />
            </div>
          </div>

          {/* RIGHT SIDE ACCORDION */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <hr className="black-line" />
              {sections.map((section, index) => (
                <div key={index} className="accordion-section">
                  <button
                    className="accordion-header"
                    onClick={() => toggleSection(index)}
                  >
                    <h3>{section.title}</h3>
                    <span
                      className={`arrow ${openIndex === index ? "open" : ""}`}
                    >
                      ▼
                    </span>
                  </button>

                  <div
                    className={`accordion-content ${
                      openIndex === index ? "show" : ""
                    }`}
                  >
                    <p>{section.text}</p>
                  </div>

                  <hr className="black-line" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EconomicCalendarContentSix;
